import { type ObjectValuesUnionType } from '../utils/typing';

export const StickyMatchActionsRowContexts = Object.freeze({
  LINE_UP: 'line-up',
});
export type StickyMatchActionsRowContext = ObjectValuesUnionType<typeof StickyMatchActionsRowContexts>;
